import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../shared/api/http.js";

export interface AdminSettings {
  smtp: {
    smtpHost: string;
    smtpPort: number | null;
    smtpUser: string;
    smtpPassSet: boolean;
    smtpSecure: boolean;
    mailFrom: string;
    mailFromName: string;
  };
  effective: {
    host: string;
    port: number;
    from: string;
    fromName: string;
    secure: boolean;
    configured: boolean;
    fromEnvFallback: boolean;
  };
}

export interface SmtpPatch {
  smtpHost?: string;
  smtpPort?: number;
  smtpUser?: string;
  smtpPass?: string;
  smtpSecure?: boolean;
  mailFrom?: string;
  mailFromName?: string;
}

const KEY = ["admin", "settings"] as const;

export const useAdminSettings = () =>
  useQuery({ queryKey: KEY, queryFn: () => http.get<AdminSettings>("/admin/settings") });

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: SmtpPatch) => http.patch<{ ok: true }>("/admin/settings", patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export const sendTestEmail = (to: string) =>
  http.post<{ sent: boolean; error?: string }>("/admin/settings/test", { to });
